import React from 'react';

interface Payment {
    paymentId?: string;
    storeName?: string;
    totalAmount?: number;
    paidByNickname?: string;
    paidBy?: string;
    splits?: Array<{
        nickname?: string;
        userId?: string;
    }>;
}

interface ExistingPaymentsListProps {
    payments: Payment[];
    totalAmount: number;
    onViewResult: () => void;
}

export const ExistingPaymentsList: React.FC<ExistingPaymentsListProps> = ({
    payments,
    totalAmount,
    onViewResult
}) => {
    return (
        <div className="existing-payments-section">
            <div className="existing-payments-header">
                <h3 className="existing-payments-title">현재까지 정산내역</h3>
                {payments.length > 0 && (
                    <span className="existing-total">총 {totalAmount.toLocaleString('ko-KR')}원</span>
                )}
            </div>
            {payments.length > 0 ? (
                <div className="existing-payments-list">
                    {payments.map((payment, index) => (
                        <div key={payment.paymentId || index} className="existing-payment-item">
                            <div className="existing-payment-info">
                                <div className="existing-payment-name">{payment.storeName || '항목 없음'}</div>
                                <div className="existing-payment-payer-row">
                                    <span className="existing-payment-payer">지불: {payment.paidByNickname || payment.paidBy || '알 수 없음'}</span>
                                    {payment.splits && payment.splits.length > 0 && (
                                        <div className="existing-split-list">
                                            {payment.splits.map((split, idx) => (
                                                <span key={idx} className="existing-split-badge">{split.nickname || split.userId}</span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="existing-payment-amount">
                                {(payment.totalAmount || 0).toLocaleString('ko-KR')}원
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="existing-payments-empty">아직 등록된 정산내역이 없습니다</div>
            )}
            <button className="view-result-button" onClick={onViewResult}>
                정산 결과 보기
            </button>
        </div>
    );
};
